import React, {FC, useCallback} from 'react';

import {DataEventActionsEnum} from '../../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {MacrosDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/macrosDataEventObject';
import {useDataEventTracking} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {useAppDispatch} from '../../../../helpers/appReduxHelpers';
import {MacrosBaseModel} from '../../../../models/api/macroModel';
import {runMacroAction} from '../../../../store/data/macros/macroActions';
import {MacroPreview} from './macroPreview';
import {InheritableTriggerButtonProps, TriggerButton} from './triggerButton';

interface MacroButtonProps extends InheritableTriggerButtonProps {
  macro: MacrosBaseModel;
  conversationId: number;
  activityId: number;
}

export const MacroButton: FC<MacroButtonProps> = ({macro, conversationId, activityId, renderDropdown}) => {
  const dispatch = useAppDispatch();

  const {trackDataEvent} = useDataEventTracking();

  const runMacro = useCallback(() => {
    trackDataEvent(DataEventActionsEnum.CLICK, MacrosDataEventObject.SUGGESTED_MACRO, {
      macro_id: macro.id,
    });
    return dispatch(runMacroAction(macro, conversationId, activityId));
  }, [activityId, conversationId, dispatch, macro, trackDataEvent]);

  return (
    <TriggerButton
      onDropdownToggle={(isOpen) => {
        if (!isOpen) {
          return;
        }
        trackDataEvent(DataEventActionsEnum.EXPAND, MacrosDataEventObject.MACRO_LIST);
      }}
      title={macro.name}
      onSelect={runMacro}
      renderDropdown={renderDropdown}
      renderPreview={(anchor, popperPlacement) => (
        <MacroPreview anchor={anchor} popperPlacement={popperPlacement} macro={macro} />
      )}
    />
  );
};
